import { ref, onMounted, onUnmounted } from 'vue'
import { Capacitor } from '@capacitor/core'

const MOBILE_BREAKPOINT = '(max-width: 767px)'

export function useIsMobile() {
    const isMobile = ref(false)
    let mq: MediaQueryList | null = null

    const onChange = (e: MediaQueryListEvent) => {
        isMobile.value = e.matches
    }

    onMounted(() => {
        if (Capacitor.isNativePlatform()) {
            isMobile.value = true
            return
        }

        mq = window.matchMedia(MOBILE_BREAKPOINT)
        isMobile.value = mq.matches
        mq.addEventListener('change', onChange)
    })

    onUnmounted(() => {
        mq?.removeEventListener('change', onChange)
    })

    return { isMobile }
}
